import React, { useEffect } from "react";
import icons from "../assets/images/sprite-other-icons.svg";
import { SplideSlide, SplideTrack, Splide } from "@splidejs/react-splide";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getFromLocalStorage, buildGameLaunchUrl } from "../services/helper/cl_Helper";
import statickImg from "../assets/images/popup/staticImg.webp";
import {
  getAffiliateGames,
  getAffiliateUserName,
  recentlyPlayedGames,
} from "../components/home/cl_LoyalltyCoins";
import { setAffiliateCode } from "../components/signUp/cl_SignUpSlice";

import HomeModal from "../components/home/HomeModal";

const HomePopularGames = ({ combinedgGames }) => {
  const { affiliateCode } = useSelector(
    (state) => state?.signUp
  );
  const token = getFromLocalStorage("gk");
  const { userDetails } = useSelector((state) => state?.signIn);
  const { gamePopup } = useSelector((state) => state?.crash);

  const {
    affiSuggestedGames,
    recommendedUserName,
    gamesRecentlyPlayed,
    loader,
  } = useSelector((state) => state?.coinsHistory);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const navigateToGamePopup = (game) => {
    const token = getFromLocalStorage("gk");
    if (token) {
      const url = buildGameLaunchUrl(game, { gameClose: true });
      window.location.href = url;
    } else {
      localStorage.setItem("pendingGame", JSON.stringify(game));
      navigate("/signin");
    }
  };

  useEffect(() => {
    const pendingGame = localStorage.getItem("pendingGame");
    if (pendingGame && token) {
      try {
        const game = JSON.parse(pendingGame);
        const url = buildGameLaunchUrl(game, { gameClose: true });
        window.location.href = url;
        localStorage.removeItem("pendingGame");
      } catch (error) {
        console.error("Error handling pending game:", error);
        localStorage.removeItem("pendingGame");
      }
    }
  }, [token]);

  // const invitationCode = userDetails?.userRefCode;

  useEffect(() => {
    if (userDetails?.userOtherInfo?.affliateBtag) {
      dispatch(getAffiliateGames(userDetails?.userOtherInfo?.affliateBtag));
      dispatch(getAffiliateUserName(userDetails?.userOtherInfo?.affliateBtag));
    } else if (affiliateCode) {
      dispatch(setAffiliateCode(affiliateCode));
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible" && userDetails?.userId) {
        dispatch(recentlyPlayedGames(token));
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    dispatch(recentlyPlayedGames(token));

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [userDetails]);

 const recentlyPlayedGamesList = gamesRecentlyPlayed
  .map((recentGame) => {
    const matchedGame = combinedgGames.find((game) => {
      if (recentGame.providerName?.toLowerCase() === "ezugi") {
        return game.name?.toLowerCase() === recentGame.gameName?.toLowerCase() &&
               game.provider?.toLowerCase() === recentGame.subProviderName?.toLowerCase();
      }
      return game.game_code === recentGame.gameCode &&
             ((recentGame.subProviderName === "Turbo" &&
               game.provider === "turbogames") ||
              game.provider?.toLowerCase() === recentGame.subProviderName?.toLowerCase());
    });

    if (matchedGame) {
      return {
        ...matchedGame,
        gameName: recentGame.gameName,
        betPlacedDate: recentGame.betPlacedDate,
      };
    }
    return null; 
  })
  .filter(Boolean) 
  .slice(0, 10);

  const popularGames =
    combinedgGames?.filter(
      (game) =>
        game.categoryname?.toLowerCase() === "popular games" ||
        game.game_type?.toLowerCase() === "common"
    ) || [];

  const uniquePopularGames = [
    ...new Set(popularGames.map((game) => JSON.stringify(game))),
  ].map((game) => JSON.parse(game));

  return (
    <>
      {gamePopup && <HomeModal />}
      {token && affiSuggestedGames?.games?.length > 0 && (
        <div className="SB-casinoCategoryItem">
          <div className="SB-casinoCategoryItem-header">
            <div className="SB-iconSVG">
              <svg xmlns="http://www.w3.org/2000/svg">
                <use xlinkHref={`${icons}#${"icon-recommended"}`} />
              </svg>
            </div>
            <div className="SB-casinoCategoryItem-title">
              {recommendedUserName?.userName} recommended games for YOU!
            </div>
          </div>
          <div className="SB-gamesList">
            <div className="splide__track">
              {affiSuggestedGames?.games?.length > 0 && (
                <ul>
                  {affiSuggestedGames?.games?.map((afGame, index) => (
                    <li key={index} onClick={() => navigateToGamePopup(afGame)}>
                      <div className="SB-gameItem">
                        <img
                          src={
                            afGame?.image?.configurl &&
                            afGame?.image?.configurl !== "NoIcon"
                              ? afGame?.image?.configurl
                              : afGame?.image?.url &&
                                afGame?.image?.url !== "NoIcon"
                              ? afGame?.image?.url
                              : statickImg
                          }
                          style={{
                            backgroundImage: `url(${afGame?.bgImg})`,
                          }}
                          onError={(e) => {
                            e.target.src = statickImg;
                          }}
                          alt={afGame?.gameName ? afGame.gameName.charAt(0).toUpperCase() + afGame.gameName.slice(1).toLowerCase() : "Game Thumbnail"}
                        />
                        <div className="SB-gameTitle">
                          {afGame?.gameName
                            ? afGame.gameName.charAt(0).toUpperCase() +
                              afGame.gameName.slice(1).toLowerCase()
                            : ""}
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      )}
      <div className="SB-gameCategory-section SB-popularGames">
        <div className="SB-casinoCategoryItem">
          {token ? (
            <React.Fragment>
              {/* COMMENTED OUT: Recently Played Games Section */}
              {recentlyPlayedGamesList?.length > 0 && (
                <>
                  <div className="SB-casinoCategoryItem-header">
                    <div className="SB-iconSVG">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                      >
                        <use xlinkHref={`${icons}#${"icon-recentlyPlayed"}`} />
                      </svg>
                    </div>
                    <div className="SB-casinoCategoryItem-title">
                      Recently Played
                    </div>
                  </div>
                  {loader ? (
                    <div className="SB-section-loader">
                      <div className="SB-section-loader-container">
                        <span className="SB-dot"></span>
                        <span className="SB-dot"></span>
                        <span className="SB-dot"></span>
                        <span className="SB-dot"></span>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="splide SB-splide-games SB-gamesList splide--slide splide--ltr splide--draggable is-active is-initialized"
                      id="splide02"
                    >
                      <div
                        className="splide__track"
                        id="splide02-track"
                        style={{ paddingLeft: "0px", paddingRight: "0px" }}
                      >
                        {recentlyPlayedGamesList.length > 0 && (
                          <Splide
                            hasTrack={false}
                            options={{
                              type: "slice",
                              autoWidth: true,
                              arrows: false,
                              pagination: false,
                              lazyLoad: "sequential",
                            }}
                          >
                            <SplideTrack>
                              {recentlyPlayedGamesList.map((game, index) => {
                                return (
                                  <SplideSlide key={index}>
                                    <div
                                      className="SB-gameItem"
                                      onClick={() => navigateToGamePopup(game)}
                                    >
                                      <img
                                        src={
                                          game?.image?.configurl &&
                                          game?.image?.configurl !== "NoIcon"
                                            ? game?.image?.configurl
                                            : game?.image?.url &&
                                              game?.image?.url !== "NoIcon"
                                            ? game?.image?.url
                                            : statickImg
                                        }
                                        style={{
                                          backgroundImage: `url(${game?.bgImg})`,
                                        }}
                                        onError={(e) => {
                                          e.target.src = statickImg;
                                        }}
                                        alt={game?.gameName ? game.gameName.charAt(0).toUpperCase() + game.gameName.slice(1).toLowerCase() : "Game Thumbnail"}
                                      />
                                      <div className="SB-gameTitle">
                                        {game?.gameName
                                          ? game.gameName
                                              .charAt(0)
                                              .toUpperCase() +
                                            game.gameName.slice(1).toLowerCase()
                                          : ""}
                                      </div>
                                    </div>
                                  </SplideSlide>
                                );
                              })}
                            </SplideTrack>
                          </Splide>
                        )}
                      </div>
                    </div>
                  )}
                </>
              )}

            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className="SB-casinoCategoryItem-header">
                <div className="SB-iconSVG">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                  >
                    <use xlinkHref={`${icons}#${"icon-populargames"}`} />
                  </svg>
                </div>
                <div className="SB-casinoCategoryItem-title">Popular Games</div>
              </div>
                <>
                  {uniquePopularGames.length > 0 ? (
                    <Splide
                    className ="SB-splide-games SB-gamesList"
                      hasTrack={false}
                      options={{
                        type: "slice",
                        autoWidth: true,
                        arrows: false,
                        pagination: false,
                        lazyLoad: "sequential",
                      }}
                    >
                      <SplideTrack>
                        {uniquePopularGames.map((game, index) => (
                          <SplideSlide key={index}>
                            <div
                              className="SB-gameItem"
                              onClick={() => navigateToGamePopup(game)}
                            >
                              <img
                                src={
                                  (game?.image?.configurl ||
                                    game?.image?.url) === "NoIcon"
                                    ? statickImg
                                    : game?.image?.configurl ||
                                      game?.image?.url ||
                                      statickImg
                                }
                                style={{
                                  backgroundImage: `url(${game?.bgImg})`,
                                }}
                                onError={(e) => {
                                  e.target.src = statickImg;
                                }}
                                alt={game?.name ? game.name.charAt(0).toUpperCase() + game.name.slice(1).toLowerCase() : "Game Thumbnail"}
                              />
                              <div className="SB-gameTitle">
                                {game?.name
                                  ? game.name.charAt(0).toUpperCase() +
                                    game.name.slice(1).toLowerCase()
                                  : ""}
                              </div>
                            </div>
                          </SplideSlide>
                        ))}
                      </SplideTrack>
                    </Splide>
                  ) : (
                    <div className="SB-msgBox">
                      <div className="SB-msgBox-container">
                        Currently there is no data available
                      </div>
                    </div>
                  )}
                </>
            </React.Fragment>
          )}
        </div>
      </div>
    </>
  );
};

export default HomePopularGames;